import { usePageChromeSlots, usePageChromeState } from '@/shared/contexts/PageChromeContext';
import { Breadcrumbs } from '../ui/Breadcrumbs/Breadcrumbs';

export function Header(): React.JSX.Element {
  const { title, description, breadcrumbs } = usePageChromeState();
  const slots = usePageChromeSlots();
  return (
    <header className="app-header">
      {breadcrumbs.length === 0 ? null : (
        <div className="app-header__breadcrumbs">
          <Breadcrumbs items={breadcrumbs} />
        </div>
      )}
      <div className="app-header__row">
        <div
          ref={(node) => {
            if (slots !== null) slots.iconSlotRef.current = node;
          }}
          className="app-header__icon"
        />
        <div className="app-header__title">
          <h1>{title ?? 'Conbent'}</h1>
          {description ? <p className="app-header__description">{description}</p> : null}
        </div>
        <div
          ref={(node) => {
            if (slots !== null) slots.actionsSlotRef.current = node;
          }}
          className="app-header__actions"
        />
      </div>
    </header>
  );
}
